import { useCallback } from "react";
import { KPI_CARDS, ROOMS } from "../helpers/constants";
import type { KpiData, KpiStatStripProps } from "../helpers/types";
import { useControllerStats } from "../../../../hooks/useControllerStats";
import { StatCard } from "../helpers/helper";



function flaggedSubLabel(data: KpiData | null): string {
  if ((data?.flaggedCount ?? 0) === 0) return "All clear";
  const parts: string[] = [];
  if ((data?.flagPIICount     ?? 0) > 0) parts.push(`${data!.flagPIICount} PII`);
  if ((data?.flagConductCount ?? 0) > 0) parts.push(`${data!.flagConductCount} Conduct`);
  if ((data?.flagOtherCount   ?? 0) > 0) parts.push(`${data!.flagOtherCount} Other`);
  return parts.join(" · ");
}
function liveStreamsSubLabel(data: KpiData | null): string {
  const live  = data?.liveStreams     ?? 0;
  const total = data?.totalCourtrooms ?? ROOMS.length;
  return live === 0 ? "" : `${live} of ${total} courtrooms active`;
}

function archivalSubLabel(data: KpiData | null): string {
  const pending = data?.archivalPending ?? 0;
  const total   = data?.archivalTotal   ?? 0;
  if (pending === 0) return total > 0 ? `${total} total requests` : "";
  return `${pending} of ${total} pending review`;
}

function recordingSubLabel(data: KpiData | null): string {
  const storage = Number(data?.storageTodayGB ?? 0);
  return storage === 0 ? "" : `${storage} GB stored`;
}

const SUB_LABEL_MAP: Record<string, (d: KpiData | null) => string> = {
  flaggedCount:    flaggedSubLabel,
  liveStreams:     liveStreamsSubLabel,
  archivalPending: archivalSubLabel,
  recordingToday:  recordingSubLabel,
};

export default function KpiStatStrip({
  activeFlagCount,
}: Readonly<KpiStatStripProps>) {
  const { data, isStale, isLoading } = useControllerStats();



const buildSubLabel = useCallback(
    (key: string) => (SUB_LABEL_MAP[key]?.(data) ?? ""),
    [data]
  );

  if (isLoading) {
    return (
      <div className="stats w-full grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-2.5">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="h-20 rounded-xl bg-gray-100 animate-pulse" />
        ))}
      </div>
    );
  }
  return (

   <div className="stats w-full grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-2.5 cursor-none">
      {KPI_CARDS.map((card) => {
        const value = card.key === "flaggedCount"
          ? (data?.flaggedCount ?? activeFlagCount)
          : data?.[card.key] ?? 0;

        const isFlashing        = card.key === "flaggedCount" && value > 0;
        const effectiveValueColor = card.key === "flaggedCount" && value === 0
          ? "#16A34A"
          : card.valueColor;


        return (
          <StatCard
            key={card.key}
            cardKey={card.key}
            label={card.label}
            scrollTo={
              card.scrollTo
            }
            dotColor={
              card.dotColor
            }

            valueColor={effectiveValueColor}

            pulse={card.pulse}
            value={value}
            subLabel={buildSubLabel(card.key)}
            isStale={isStale}
            isFlashing={
              isFlashing
            }
          />
        );
      })}
    </div>

  );
}